// Author Liang Gangqiang
// Date 2021-07-17 11:58:31

class SithMesNcrTaskNccItem {
constructor({
        id = null,
        name = '',
        englishName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.englishName = englishName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesNcrTaskNccItem();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'englishName',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.grid.englishName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    englishNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'englishNameFilter',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.filter.englishName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'englishName',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.entity.englishName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesNcrTaskNccItem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesNcrTaskNccItem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
